<template>
    <div id="main" :class="{is_loading: $store.state.Main.loading}">
        <transition name="slide-fade" mode="out-in">
            <router-view></router-view>
        </transition>
        <div class="loader_wrapper" v-if="$store.state.Main.loading">
            <div class="loader"></div>
        </div>
    </div>
</template>
<style>
    #main.is_loading {
        overflow: hidden;
        /*background: black;*/
    }
    .loader_wrapper {
        display: flex;
        width: 100vw;
        height: 100vh;
        position: absolute;
        z-index: 1000000;
        top: 0;
        justify-content: center;
        align-items: center;
        background-color: #000000c7;
        left: 0;
    }
    .loader {
        border: 5px solid #f3f3f3;
        border-top: 5px solid #3498db;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        animation: spin 1s linear infinite;
        -webkit-animation: spin 1s linear infinite;
        -moz-animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @-webkit-keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @-moz-keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0;
    }

    .slide-fade-enter-active {
        transition: all 0.2s ease;
    }

    .slide-fade-leave-active {
        transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter,
    .slide-fade-leave-to {
        opacity: 0;
    }

    #main {
        height: 100%;
        display: flex;
        flex-direction: column;
    }
</style>
<script>

    import firebase from './Firebase';

    export default {
        name: 'Main',
        beforeCreate() {
            this.$store.dispatch('fetchConfigVars');
            this.$store.dispatch('initialiseStore');
        },
        computed: {
            isFetchConfigVarsSuccessful() {
                return this.$store.state.Config.fetchConfigVarsError === null;
            }
        },
        watch: {
            isFetchConfigVarsSuccessful(success) {
                if (success) {
                    firebase.init(this.$store.state.Config.firebase);
                    console.log('App: Firebase initialized');
                } else {
                    console.log('App: Could not initialize firebase');
                }
            }
        }
    }
</script>
<style src="../public/assets/vendors/base/vendors.bundle.css"></style>
<style src="../public/assets/demo/default/base/style.bundle.css"></style>
